import { __decorate } from "tslib";
import { AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
import { LogotypeImageResolution } from "./logotype_image_resolution";
export var LogotypeImageType;
(function (LogotypeImageType) {
    LogotypeImageType[LogotypeImageType["grayScale"] = 0] = "grayScale";
    LogotypeImageType[LogotypeImageType["color"] = 1] = "color";
})(LogotypeImageType || (LogotypeImageType = {}));
export class LogotypeImageInfo {
    constructor(params = {}) {
        this.type = LogotypeImageType.color;
        this.fileSize = 0;
        this.xSize = 0;
        this.ySize = 0;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({
        type: AsnPropTypes.Integer,
        context: 0,
        implicit: true,
        defaultValue: LogotypeImageType.color,
    })
], LogotypeImageInfo.prototype, "type", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], LogotypeImageInfo.prototype, "fileSize", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], LogotypeImageInfo.prototype, "xSize", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], LogotypeImageInfo.prototype, "ySize", void 0);
__decorate([
    AsnProp({ type: LogotypeImageResolution })
], LogotypeImageInfo.prototype, "resolution", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String, context: 4, implicit: true, optional: true })
], LogotypeImageInfo.prototype, "language", void 0);
